import { render, staticRenderFns } from "./secondaryPagesYYLY.vue?vue&type=template&id=4bf9c64e&scoped=true&"
import script from "./secondaryPagesYYLY.vue?vue&type=script&lang=js&"
export * from "./secondaryPagesYYLY.vue?vue&type=script&lang=js&"
import style0 from "./secondaryPagesYYLY.vue?vue&type=style&index=0&id=4bf9c64e&lang=scss&scoped=true&"
import style1 from "./secondaryPagesYYLY.vue?vue&type=style&index=1&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4bf9c64e",
  null
  
)

export default component.exports